module.exports = __webpack_public_path__ + "img/new_hengbanshipin.db5c4529.png";